module.exports = __webpack_public_path__ + "static/assets/1dafaf48cee4f371d2d0996de78034a2.svg";